// @flow

import React from "react"
import styles from "./styles.css"

const SectionSeparator = ( { title }: { title: string } ) => (
  <div className={styles.root}>
    <div
      className={styles.line}
      style={{
        width: "26px",
        flex: "initial",
      }}
    />
    <div className={styles.title}>{title}</div>
    <div className={styles.line} />
  </div>
)

export default SectionSeparator



// WEBPACK FOOTER //
// ./src/components/SectionSeparator/index.jsx